// Equipe items for mobile more support
export function equipeItems() {
  
  [...document.querySelectorAll('.equipe__items')]?.forEach( equipeItems => {
    const equipeMore = document.querySelector('.js-more');
    const equipeMoreText = document.querySelector('.js-more .wp-element-button');

    // Count items
    const equipItemCount = [...equipeItems.querySelectorAll('.equipe__item')]?.length;
    equipeItems.style.cssText += '--equipe-items: ' + equipItemCount/2 + '';

    equipeMore.addEventListener('click', function(){
      equipeItems.parentElement.classList.toggle('is-open');
      
      if (equipeMoreText.innerHTML === "voir moins") {
        equipeMoreText.innerHTML = "voir plus";
      } else {
        equipeMoreText.innerHTML = "voir moins";
      }
    })

  })
}